import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import * as theme from '../components/pages/theme/index';
import InContextTheme from './pages/InContextTheme';

class ConditionalThemeRoute extends Component {
    render() {
        const { isThemeSbem, ThemeComponent, ...props } = this.props;
        return (
            <div>
                {isThemeSbem ? (
                    <InContextTheme {...props} />
                ) : (
                    <ThemeComponent {...props} />
                )}
            </div>
        );
    }
}

ConditionalThemeRoute.propTypes = {
    isThemeSbem: PropTypes.bool.isRequired,
    ThemeComponent: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    code: get(state, 'app.selected.code'),
    themeList: get(state, 'app.selected.themeList', []),
    isThemeSbem: state.app.selected.isThemeSbem
});

export default connect(mapStateToProps)(ConditionalThemeRoute);



// WEBPACK FOOTER //
// ./src/components/ConditionalThemeRoute.js